// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-to-buy-balance-container-Nm0ue {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: safe center;
  gap: 20px;
  height: 100vh;
  overflow: auto;
  background-color: var(--color-white);
  background-image:
    radial-gradient(ellipse at 5% 10%, color-mix(in oklch, var(--color-red-50) 65%, var(--color-red-100)), transparent 40%),
    radial-gradient(ellipse at 95% 20%, color-mix(in oklch, var(--color-orange-50) 65%, var(--color-orange-100)), transparent 40%),
    radial-gradient(ellipse at 65% 100%, color-mix(in oklch, var(--color-rose-50) 65%, var(--color-rose-100)), transparent 50%);
  padding: 40px 24px;
}

.how-to-buy-balance-header-jMRSo {
  flex-shrink: 0;
  margin-bottom: 24px;
}

.how-to-buy-balance-content-sTQ2r {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  max-width: 100%;
  text-align: center;
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-3xl);
  padding: 32px;
}

.how-to-buy-balance-content-sTQ2r > * {
  flex-shrink: 0;
}

.how-to-buy-balance-iconContainer-YSFK5 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: var(--color-blue-50);
  border-radius: 50%;
}

.how-to-buy-balance-heroIcon-tZ3ZN {
  --size: 40px;
  color: var(--color-blue-600);
}

.how-to-buy-balance-title-PRBRT {
  color: var(--color-neutral-900);
  font-size: var(--text-xl);
  font-weight: var(--font-weight-medium);
  line-height: 1.25;
  margin: 24px 0px 0px;
}

.how-to-buy-balance-intro-lBYfJ {
  color: var(--color-neutral-600);
  font-size: 15px;
  line-height: 1.5;
  margin: 20px 0px 0px;
}

.how-to-buy-balance-reference-yhRLd {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: var(--color-sky-700);
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
  margin: 12px 0px 0px;
  border: 1px solid var(--color-sky-200);
  border-radius: var(--radius-xl);
  background-color: var(--color-sky-100);
  padding: 8px;
}

.how-to-buy-balance-referenceIcon-wgSeO {
  --size: 20px;
  flex-shrink: 0;
}

.how-to-buy-balance-referenceText-BbWBa {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.how-to-buy-balance-bankSection-FN6IW {
  width: 100%;
  text-align: left;
  background-color: var(--color-white);
  border: 1px solid var(--color-neutral-200);
  border-radius: var(--radius-xl);
  padding: 16px;
  margin-top: 16px;
}

.how-to-buy-balance-bankTitle-DumhY {
  color: var(--color-neutral-900);
  font-size: var(--text-lg);
  font-weight: var(--font-weight-medium);
  margin: 0px;
}

.how-to-buy-balance-bankOwner-qLTxK {
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
  line-height: 1.5;
  margin: 8px 0px 0px;
}

.how-to-buy-balance-bankList-Rkeij {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0px;
  margin: 16px 0px 0px;
}

.how-to-buy-balance-bankAccount-aZUaW {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0px;
}

.how-to-buy-balance-bankAccount-aZUaW:not(:first-of-type) {
  border-top: 1px solid var(--color-neutral-200);
}

.how-to-buy-balance-bankLogo-wl3cz {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.how-to-buy-balance-bankDetails-t2ujo {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  min-width: 0px;
}

.how-to-buy-balance-bankHeading-RsECy {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
}

.how-to-buy-balance-bankName-I6aTe {
  color: var(--color-neutral-900);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}

.how-to-buy-balance-bankType-S1Xee {
  color: var(--color-neutral-600);
  font-size: var(--text-xs);
}

.how-to-buy-balance-bankNumber-EVV7U {
  color: var(--color-neutral-900);
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
}

.how-to-buy-balance-actions-FmJZi {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: 20px;
}

.how-to-buy-balance-receiptButton-ESO0f {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 380px;
  max-width: 100%;
  min-height: 44px;
  color: var(--color-white);
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  background-color: var(--color-blue-500);
  border-radius: var(--radius-md);
  padding: 10px 16px;
}

.how-to-buy-balance-receiptButton-ESO0f:active {
  background-color: var(--color-blue-600);
  text-decoration: none;
}

.how-to-buy-balance-receiptIcon-NG5Uv {
  width: 19px;
  height: 19px;
  fill: currentColor;
}

.how-to-buy-balance-salesButton-MV49X {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 380px;
  max-width: 100%;
  min-height: 44px;
  color: var(--color-blue-500);
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
  border: 1px solid var(--color-blue-500);
  border-radius: var(--radius-md);
  padding: 10px 16px;
}

.how-to-buy-balance-salesButton-MV49X:active {
  background-color: var(--color-blue-50);
  text-decoration: none;
}

.how-to-buy-balance-salesIcon-NORrZ {
  --size: 24px;
}

.how-to-buy-balance-salesNote-zFLje {
  max-width: 380px;
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
  line-height: 1.5;
  padding: 0px 8px;
  margin: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/how-to-buy-balance/how-to-buy-balance.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC;;;+HAG6H;EAC7H,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,uCAAuC;EACvC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,+BAA+B;EAC/B,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: safe center;\n  gap: 20px;\n  height: 100vh;\n  overflow: auto;\n  background-color: var(--color-white);\n  background-image:\n    radial-gradient(ellipse at 5% 10%, color-mix(in oklch, var(--color-red-50) 65%, var(--color-red-100)), transparent 40%),\n    radial-gradient(ellipse at 95% 20%, color-mix(in oklch, var(--color-orange-50) 65%, var(--color-orange-100)), transparent 40%),\n    radial-gradient(ellipse at 65% 100%, color-mix(in oklch, var(--color-rose-50) 65%, var(--color-rose-100)), transparent 50%);\n  padding: 40px 24px;\n}\n\n.header {\n  flex-shrink: 0;\n  margin-bottom: 24px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 500px;\n  max-width: 100%;\n  text-align: center;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-200);\n  border-radius: var(--radius-3xl);\n  padding: 32px;\n}\n\n.content > * {\n  flex-shrink: 0;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  background-color: var(--color-blue-50);\n  border-radius: 50%;\n}\n\n.heroIcon {\n  --size: 40px;\n  color: var(--color-blue-600);\n}\n\n.title {\n  color: var(--color-neutral-900);\n  font-size: var(--text-xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.25;\n  margin: 24px 0px 0px;\n}\n\n.intro {\n  color: var(--color-neutral-600);\n  font-size: 15px;\n  line-height: 1.5;\n  margin: 20px 0px 0px;\n}\n\n.reference {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  color: var(--color-sky-700);\n  text-align: left;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 12px 0px 0px;\n  border: 1px solid var(--color-sky-200);\n  border-radius: var(--radius-xl);\n  background-color: var(--color-sky-100);\n  padding: 8px;\n}\n\n.referenceIcon {\n  --size: 20px;\n  flex-shrink: 0;\n}\n\n.referenceText {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.bankSection {\n  width: 100%;\n  text-align: left;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-neutral-200);\n  border-radius: var(--radius-xl);\n  padding: 16px;\n  margin-top: 16px;\n}\n\n.bankTitle {\n  color: var(--color-neutral-900);\n  font-size: var(--text-lg);\n  font-weight: var(--font-weight-medium);\n  margin: 0px;\n}\n\n.bankOwner {\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n  line-height: 1.5;\n  margin: 8px 0px 0px;\n}\n\n.bankList {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding: 0px;\n  margin: 16px 0px 0px;\n}\n\n.bankAccount {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0px;\n}\n\n.bankAccount:not(:first-of-type) {\n  border-top: 1px solid var(--color-neutral-200);\n}\n\n.bankLogo {\n  width: 36px;\n  height: 36px;\n  object-fit: contain;\n}\n\n.bankDetails {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0px;\n}\n\n.bankHeading {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px 8px;\n}\n\n.bankName {\n  color: var(--color-neutral-900);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n.bankType {\n  color: var(--color-neutral-600);\n  font-size: var(--text-xs);\n}\n\n.bankNumber {\n  color: var(--color-neutral-900);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n}\n\n.actions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.receiptButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 380px;\n  max-width: 100%;\n  min-height: 44px;\n  color: var(--color-white);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n  background-color: var(--color-blue-500);\n  border-radius: var(--radius-md);\n  padding: 10px 16px;\n}\n\n.receiptButton:active {\n  background-color: var(--color-blue-600);\n  text-decoration: none;\n}\n\n.receiptIcon {\n  width: 19px;\n  height: 19px;\n  fill: currentColor;\n}\n\n.salesButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 380px;\n  max-width: 100%;\n  min-height: 44px;\n  color: var(--color-blue-500);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n  border: 1px solid var(--color-blue-500);\n  border-radius: var(--radius-md);\n  padding: 10px 16px;\n}\n\n.salesButton:active {\n  background-color: var(--color-blue-50);\n  text-decoration: none;\n}\n\n.salesIcon {\n  --size: 24px;\n}\n\n.salesNote {\n  max-width: 380px;\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n  line-height: 1.5;\n  padding: 0px 8px;\n  margin: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `how-to-buy-balance-container-Nm0ue`,
	"header": `how-to-buy-balance-header-jMRSo`,
	"content": `how-to-buy-balance-content-sTQ2r`,
	"iconContainer": `how-to-buy-balance-iconContainer-YSFK5`,
	"heroIcon": `how-to-buy-balance-heroIcon-tZ3ZN`,
	"title": `how-to-buy-balance-title-PRBRT`,
	"intro": `how-to-buy-balance-intro-lBYfJ`,
	"reference": `how-to-buy-balance-reference-yhRLd`,
	"referenceIcon": `how-to-buy-balance-referenceIcon-wgSeO`,
	"referenceText": `how-to-buy-balance-referenceText-BbWBa`,
	"bankSection": `how-to-buy-balance-bankSection-FN6IW`,
	"bankTitle": `how-to-buy-balance-bankTitle-DumhY`,
	"bankOwner": `how-to-buy-balance-bankOwner-qLTxK`,
	"bankList": `how-to-buy-balance-bankList-Rkeij`,
	"bankAccount": `how-to-buy-balance-bankAccount-aZUaW`,
	"bankLogo": `how-to-buy-balance-bankLogo-wl3cz`,
	"bankDetails": `how-to-buy-balance-bankDetails-t2ujo`,
	"bankHeading": `how-to-buy-balance-bankHeading-RsECy`,
	"bankName": `how-to-buy-balance-bankName-I6aTe`,
	"bankType": `how-to-buy-balance-bankType-S1Xee`,
	"bankNumber": `how-to-buy-balance-bankNumber-EVV7U`,
	"actions": `how-to-buy-balance-actions-FmJZi`,
	"receiptButton": `how-to-buy-balance-receiptButton-ESO0f`,
	"receiptIcon": `how-to-buy-balance-receiptIcon-NG5Uv`,
	"salesButton": `how-to-buy-balance-salesButton-MV49X`,
	"salesIcon": `how-to-buy-balance-salesIcon-NORrZ`,
	"salesNote": `how-to-buy-balance-salesNote-zFLje`
};
export default ___CSS_LOADER_EXPORT___;
